import { render, staticRenderFns } from "./ChirpList.vue?vue&type=template&id=85819bca"
import script from "./ChirpList.vue?vue&type=script&lang=js"
export * from "./ChirpList.vue?vue&type=script&lang=js"
import style0 from "./ChirpList.vue?vue&type=style&index=0&id=85819bca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports